$(document).ready(function() {
    $('.tabs ul li.item a').first().addClass('is-active');
    $('.tab-content .tab-content-item').first().addClass('is-active');

    $('.tabs ul li.item a').on('click', function() {
        var number = $(this).data('option');
        $('.tabs ul li.item a').removeClass('is-active');
        $(this).addClass('is-active');

        $('.tab-content .tab-content-item').removeClass('is-active');
        $('div[data-item="' + number + '"]').addClass('is-active');
    });
});
